/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  beneficiaryAccountDetailsById,
  resetUpdateBeneficiaryAccount,
  updateBeneficiaryAccount,
} from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import Validation from "../../../../../utils/validation";
import globalText from "../../../../../utils/globalText.js";

const BeneficiaryAccountEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const [, setIsMobile] = useState(window.innerWidth <= 1024);
  const [isLeavePopupOpen, setIsLeavePopupOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isUpdatingAccount, setIsUpdatingAccount] = useState(false);
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(false);
  const [selectedAccountNameOption, setSelectedAccountNameOption] =
    useState("");
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
    bankAccountName: "",
  });

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const { beneficiaryAccountDetailsData, beneficiaryAccountDetailsLoading } =
    useSelector((state) => state.beneficiaryAccount);

  const beneficiaryAccount =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: isUpdateButtonEnabled && !isUpdatingAccount,
      previousIsDisabled: isUpdatingAccount,
      nextIsLoading: isUpdatingAccount,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: isUpdatingAccount
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "Contact details",
    },
  ];

  const isContactValid =
    !formErrors.contact_no && payload?.contact_no.length === 10;

  const isEmailValid =
    !formErrors.email_id && Validation.emailRegex.test(payload?.email_id);

  const isAccountNameValid =
    payload.account_name.trim().length >= 3 && !formErrors.account_name;

  const isFormValid = isContactValid && isEmailValid;

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };
  const validationMap = {
    email_id: Validation.validateEmail,
    contact_no: Validation.validateContactNum,
    account_name: Validation.validateAccountName,
  };

  const validateAndRecordError = (name, value) => {
    const errors = { ...formErrors };
    validationMap[name]?.(name, value, errors);
    setFormErrors(errors);
  };

  const getUpdatedFields = () => {
    const fields = [];

    if (beneficiaryAccount?.contact_no !== payload.contact_no)
      fields.push("contact_no");
    if (beneficiaryAccount?.email_id?.trim() !== payload.email_id?.trim()) {
      fields.push("email_id");
    }
    if (beneficiaryAccount?.name?.trim() !== payload.account_name?.trim()) {
      fields.push("account_name");
    }

    return fields;
  };

  const handleBack = () => {
    if (hasUnsavedChanges) {
      setIsLeavePopupOpen(true);
      return;
    }
    navigate(-1);
  };

  const handleLeavePage = () => {
    navigate(-1);
  };

  const handleAccountNameOptionChange = ({ target: { value } }) => {
    setSelectedAccountNameOption(value);
    updateAccountNameBySelection(value);
  };

  const handleAccountNameOptionSelect = (value) => {
    setSelectedAccountNameOption(value);
    updateAccountNameBySelection(value);
  };



  const updateAccountNameBySelection = (selectedOption) => {
    setPayload((prevPayload) => {
      if (selectedOption === "legalname") {
        return {
          ...prevPayload,
          account_name: beneficiaryAccount?.pan_legal_name || "",
        };
      }
      if (selectedOption === "bankaccountname") {
        return {
          ...prevPayload,
          account_name: prevPayload.bankAccountName || "",
        };
      }

      const hasCustomAccountName =
        prevPayload.account_name.trim().length > 0 &&
        prevPayload.account_name.trim() !==
          (beneficiaryAccount?.pan_legal_name || "").trim() &&
        prevPayload.account_name.trim() !==
          (prevPayload.bankAccountName || "").trim();

      return {
        ...prevPayload,
        account_name: hasCustomAccountName
          ? prevPayload.account_name
          : beneficiaryAccount?.name || "",
      };
    });
  };

  const handleChange = (e) => {
    const { name, value: inputValue } = e.target;
    if (name === "account_name") {
      if (inputValue.startsWith(" ")) return;

      if (/ {2,}/.test(inputValue)) return;
    }
    const newValue =
      name === "account_name"
        ? inputValue
        : inputValue.replace(/[^a-zA-Z0-9@.]/g, "").trim();

    if (!allowedValue(name, inputValue)) return;
    validateAndRecordError(name, newValue);
    const updatedPayload = {
      ...payload,
      [name]: newValue,
    };
    setPayload(updatedPayload);
    setHasUnsavedChanges(
      beneficiaryAccount?.contact_no !== updatedPayload.contact_no ||
        beneficiaryAccount?.email_id !== updatedPayload.email_id ||
        beneficiaryAccount?.name?.trim() !==
          updatedPayload.account_name?.trim(),
    );
    if (inputValue.trim() === "" && inputValue.length === 1) {
      return;
    }
    if (
      name === "account_name" &&
      newValue === beneficiaryAccount?.pan_legal_name
    ) {
      setSelectedAccountNameOption("legalname");
    } else if (
      name === "account_name" &&
      newValue === payload.bankAccountName
    ) {
      setSelectedAccountNameOption("bankaccountname");
    } else if (name === "account_name") {
      setSelectedAccountNameOption("customname");
    }
  };

 

  const handleUpdateAccount = async () => {
    if (isUpdatingAccount) return;

    try {
      setIsUpdatingAccount(true);
      const response = await dispatch(
        updateBeneficiaryAccount({
          id,
          email: payload?.email_id,
          contact_no: payload?.contact_no,
          name: payload?.account_name,
        }),
      );
      if (response?.payload?.status) {
        const updatedFields = getUpdatedFields();
        dispatch(resetUpdateBeneficiaryAccount());
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/contact_edit_success/${id}`,
          {
            state: {
              selectedAccountNameOption:selectedAccountNameOption,
              updatedFields:
                updatedFields.length > 0
                  ? updatedFields
                  : ["contact_no", "email_id", "account_name"],
            },
          },
        );
      }
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setIsUpdatingAccount(false);
    }
  };

  useEffect(() => {
    if (
      beneficiaryAccountDetailsLoading ||
      beneficiaryAccountDetailsData?.status !== true ||
      !beneficiaryAccount
    ) {
      return;
    }

    setPayload((prevPayload) => ({
      ...prevPayload,
      contact_no: beneficiaryAccount.contact_no,
      email_id: beneficiaryAccount.email_id,
      account_name: beneficiaryAccount.name,
      legalName: beneficiaryAccount.pan_legal_name,
      bankAccountName: beneficiaryAccount.bank_account_holder_full_name || "",
    }));

    const normalizedName = (beneficiaryAccount.name || "").trim().toLowerCase();
    const normalizedLegalName = (beneficiaryAccount.pan_legal_name || "")
      .trim()
      .toLowerCase();
    const normalizedBankAccountName = (
      beneficiaryAccount.bank_account_holder_full_name || ""
    )
      .trim()
      .toLowerCase();
    setSelectedAccountNameOption(
      normalizedName && normalizedName === normalizedLegalName
        ? "legalname"
        : normalizedName && normalizedName === normalizedBankAccountName
          ? "bankaccountname"
          : "customname",
    );
  }, [
    beneficiaryAccount,
    beneficiaryAccountDetailsData?.status,
    beneficiaryAccountDetailsLoading,
  ]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsLoading ||
      beneficiaryAccountDetailsData?.status !== true
    ) {
      return;
    }

    const hasChanges =
      beneficiaryAccount?.contact_no !== payload.contact_no ||
      beneficiaryAccount?.email_id !== payload.email_id ||
      beneficiaryAccount?.name?.trim() !== payload.account_name?.trim();

    const canUpdate = hasChanges && isFormValid && isAccountNameValid;
    setIsUpdateButtonEnabled(canUpdate);
  }, [
    payload,
    formErrors,
    beneficiaryAccount,
    beneficiaryAccountDetailsLoading,
    beneficiaryAccountDetailsData,
  ]);

  useEffect(() => {
    (async () => {
      const response = await dispatch(beneficiaryAccountDetailsById({ id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    })();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    if (!isLoading && services !== null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  return (
    <>
      {isLeavePopupOpen && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            subtext={globalText?.EXIT_CURRENT_FLOW_NOTE}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            btnOneText={globalText?.STAY}
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setIsLeavePopupOpen(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleLeavePage}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="flex flex-col items-center max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md">
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <TopNavComponent
              topNavHeader="Beneficiary Account"
              topNavSubText="Contact details"
              isFormattingNotRequired
            />
          </div>
          <div className="h-mobile-create-header block Qmd:hidden"></div>
        </div>
        <div
          className="max-w-tab-width-normal mx-auto w-full py-padding-md px-padding-md Qlg:px-padding-base flex-1 overflow-y-auto"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="w-width-full">
            <div
              className="max-w-tab-width-normal w-full mx-auto"
              style={{ scrollbarWidth: "none" }}
            >
              <CommonLayout>
                <AccountName
                  handleChange={handleChange}
                  accountNameValidation={isAccountNameValid}
                  accountName={payload.account_name}
                  selectedValue={selectedAccountNameOption}
                  handleDivBtn={handleAccountNameOptionSelect}
                  handleRadioBtn={handleAccountNameOptionChange}
                  selectedRadioValue={selectedAccountNameOption}
                  legalName={payload?.legalName}
                  bankAccountName={payload?.bankAccountName}
                />
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={isContactValid}
                  emailValidation={isEmailValid}
                  contactNumber={payload?.contact_no}
                  emailId={payload?.email_id}
                  selectedValue={selectedAccountNameOption}
                />
              </CommonLayout>
            </div>
          </div>
        </div>
        <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
      </div>
    </>
  );
};

export default BeneficiaryAccountEditContact;
